/* import __COLOCATED_TEMPLATE__ from './address-input-field-street1-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldStreet1 from './address-input-field-street1';
let AddressInputFieldStreet1Old = (_dec = tagName(''), _dec(_class = class AddressInputFieldStreet1Old extends AddressInputFieldStreet1 {}) || _class);
export { AddressInputFieldStreet1Old as default };